import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const EDITOR_EMTPY_TEXT = '<p><br></p>';

const TextEditor = ({ callback, value }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    if (value) {
      setContent(value);
    }
  }, [value]);

  const onChange = (value, delta, source, editor) => {
    const text = editor.getText();
    const content = text ? value : null;
    setContent(content);
    callback(content);
  };

  return (
    <ReactQuill
      theme="snow"
      value={content}
      onChange={onChange}
    />
  );
};

export default TextEditor;
